<template>
  <div>
    <h1 class="text-2xl mb-6">Gestion des UTM Content suivis</h1>
    <UtmContentWhitelistTable
      ref="utmContentWhitelistTable"
    ></UtmContentWhitelistTable>
    <v-row justify="center" class="mt-6 mb-6">
      <v-btn class="primary" @click="dialog = true"
        >Ajouter un UTM Content</v-btn
      >
    </v-row>
    <v-dialog v-model="dialog">
      <UtmContentCreation
        @close-dialog="dialog = false"
        @saved="handleContentSaved"
      ></UtmContentCreation>
    </v-dialog>
    <v-snackbar v-model="showSuccessMessage" color="success" timeout="3000" top>
      UTM Content créé avec succès
    </v-snackbar>
  </div>
</template>
<script>
import UtmContentWhitelistTable from "@/components/acquisition/utm-content/tables/UtmContentWhitelistTable.vue";
import UtmContentCreation from "@/components/acquisition/utm-content/cards/UtmContentCreation.vue";
export default {
  name: "AcquiUtmContentWhitelist",
  components: { UtmContentWhitelistTable, UtmContentCreation },
  data() {
    return {
      dialog: false,
      showSuccessMessage: false,
    };
  },
  methods: {
    handleContentSaved() {
      this.dialog = false;
      this.showSuccessMessage = true;
      this.$refs.utmContentWhitelistTable.getData();
    },
  },
};
</script>
<style></style>
